<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-video', fontSet: 'fad'}"
	[headerText]="data?.media?.name || data?.mediaName"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div [class.videoError]="videoError" class="videoContainer">
			@if (videoError) {
				<div class="errorLoading">
					<i class="fad fa-file-video fa-3x"></i>
					<div class="text">
						{{ T.EDIT_MEDIA_DIALOG_VIDEO_LOAD_ERROR | translate }}
					</div>
				</div>
			}

			@if (data?.media) {
				<video
					(error)="videoError = true"
					[src]="simUtilityService.getMediaPath(data?.media)"
					controls
					preload="metadata"
					style="height: 100%"
				></video>
			}
			@if (data?.mediaUrl) {
				<video (error)="videoError = true" [src]="data?.mediaUrl" controls preload="metadata" style="height: 100%"></video>
			}
		</div>
	</ng-container>
</sim-basic-material-dialog>
